import React from 'react';
import { testimonials } from '../data/constants';
export function Testimonials() {
  return <section className="py-16 px-4 max-w-6xl mx-auto" data-id="element-263">
      <div className="grid md:grid-cols-3 gap-6" data-id="element-264">
        {testimonials.map((t, i) => <div key={i} className="bg-surface border border-zinc-800 p-6 rounded-2xl flex flex-col h-full" data-id="element-265">
            <div className="flex items-center gap-3 mb-4" data-id="element-266">
              <div className="w-12 h-12 rounded-full bg-zinc-800 flex items-center justify-center font-space-grotesk font-bold text-lg text-zinc-300" data-id="element-267">
                {t.initials}
              </div>
              <div data-id="element-268">
                <div className="font-bold text-white" data-id="element-269">{t.name}</div>
                <div className="text-xs text-zinc-400" data-id="element-270">
                  {t.location} · {t.role}
                </div>
              </div>
            </div>
            <div className="text-yellow-400 text-sm mb-3" data-id="element-271">⭐⭐⭐⭐⭐</div>
            <p className="text-zinc-300 italic flex-grow" data-id="element-272">"{t.text}"</p>
          </div>)}
      </div>
    </section>;
}